<template>
  <div
    type="tab-composite-view"
    title="tab-composite"
    class="tab-slide"
  >
    <div slot="content">
      <component
        :is="tabDatas[selected].component"
        v-if="selected !== -1"
        v-show="tabDatas[selected].show"
        ref="content"
        :data="tabDatas[selected].data"
        class="module"
      />
    </div>
    <!-- 新增评论弹窗 -->
    <add-comment-modal
      :visible.sync="showAddCommentModal"
      :inquiry-id="inquiryId"
    />
    <!-- 设置回访提醒弹窗 -->
    <set-remind-modal
      :visible.sync="showSetRemindModal"
      :inquiry-id="inquiryId"
    />
    <!-- 变更历史详情 -->
    <change-detail
      v-if="historyDetailId"
      :visible="showHistoryDetailModal"
      :detail-id.sync="historyDetailId"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import eventBus from '@/lib/eventBus'
import BaseDetail from './BaseDetail'
import InforFrom from './InforFrom'
import ReturnVisite from './ReturnVisite'
import CommentContent from './CommentContent'
import AddCommentModal from './modal/AddCommit'
import SetRemindModal from './modal/SetRemindModal'
import ChangeHistory from './ChangHistory/List'
import ChangeDetail from './ChangHistory/ChangeDetail'
import FollowupReply from './AddFollowupReply'
import CommentReply from './AddCommentReply'
import AddFollowup from './AddFollowup'
import Archive from './Archive'

export default {
  components: {
    BaseDetail,
    InforFrom,
    ReturnVisite,
    CommentContent,
    AddCommentModal,
    SetRemindModal,
    AddFollowup,
    ChangeHistory,
    ChangeDetail,
    FollowupReply,
    CommentReply
  },
  props: {
    formData: {
      type: Object,
      default: () => { }
    },
    detailData: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      selectedLabel: this.$t('message["1378"]'),
      selected: 0,
      showAddCommentModal: false,
      showSetRemindModal: false,
      showHistoryDetailModal: false,
      historyDetailId: ''
    }
  },
  computed: {
    ...mapState('inquery/detailData', [
      'followup'
    ]),
    ...mapGetters('inquery/detailData', ['permissionInfo']),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    tabkey () {
      return this.$route.query.tab
    },
    currentTab: {
      get () {
        return this.$route.query.tab || 'baseDetail'
      },
      set (val) {
      }
    },
    otherData () {
      let data = [{
        fieldname: this.$t('message["448"]'),
        fieldkey: 'return_info',
        spread: true,
        show: this.permissionInfo.is_show_followups
      }, {
        fieldname: this.$t('message["716"]'),
        fieldkey: 'comment_info',
        spread: true,
        show: this.permissionInfo.is_show_comments
      }]
      return data
    },
    newFormData () {
      let arr = []
      for (let key in this.formData) {
        let modules = this.formData[key]
        modules.show = true
        modules.spread = true
        if (this.$toType(modules) === 'object') {
          arr.push(modules)
        }
        if (!modules.child || !modules.child.length) {
          modules.show = false
        }
      }

      arr.splice(1, 0, ...this.otherData)

      arr.push({
        fieldname: this.$t('message["583"]'),
        fieldkey: 'info_detail',
        spread: true,
        show: this.permissionInfo.is_show_fromdetail
      })

      let obj = _.reduce(arr, (res, item, i) => {
        res[item.fieldkey] = item
        return res
      }, {})

      return obj
    },
    tabDatas () {
      if (!this.formData) return
      delete this.formData.from_info
      delete this.formData.info

      let data = [{
        key: 'baseDetail',
        label: this.$t('message["1378"]'),
        component: BaseDetail,
        data: this.newFormData,
        show: this.permissionInfo.is_show_inquirydetail
      },
      {
        key: 'changeHistory',
        label: this.$t('message["48"]'),
        component: ChangeHistory,
        show: this.permissionInfo.is_show_historys
      },
      {
        key: 'followupReply',
        label: this.$t('message["441"]'),
        component: FollowupReply,
        show: this.permissionInfo.is_show_followups
      },
      {
        key: 'commentReply',
        label: this.$t('message["715"]'), // 评论回复
        component: CommentReply,
        show: this.permissionInfo.is_add_comments
      },
      {
        key: 'addFollowup',
        label: this.$t('message["1692"]'), // 新增回访
        component: AddFollowup,
        show: this.permissionInfo.is_add_followups
      },
      {
        key: 'archive',
        label: this.$t('message["417"]'), // 归档
        component: Archive,
        show: this.permissionInfo.is_show_archive
      }
      ]
      return data
    }
  },
  watch: {
    tabkey (val) {
      if (val === 'baseDetail') {
        this.selected = 0
      } else if (val === 'changeHistory') {
        this.selected = 1
      } else if (val === 'followupReply') {
        this.selected = 2
      } else if (val === 'commentReply') {
        this.selected = 3
      } else if (val === 'addFollowup') {
        this.selected = 4
      } else if (val === 'archive') {
        this.selected = 5
      }
    }
  },
  created () {
    this.selectedKey = this.currentTab
    // index
    this.selected = _.findIndex(this.tabDatas, (item) => item.key === this.selectedKey)
    if (this.selected !== -1) {
      this.selectedLabel = this.tabDatas[this.selected].label
    }

    eventBus.$on('openCommentModal', () => {
      this.showAddCommentModal = true
    })
    eventBus.$on('openSetRemindModal', (remind) => {
      this.showSetRemindModal = true
      eventBus.$emit('setRemindModalData', remind || this.followup.remind)
    })

    eventBus.$on('toggleHistoryDetailModal', (show, id) => {
      this.showHistoryDetailModal = show
      this.historyDetailId = id
    })
  },
  methods: {
    changeHandlerTab (label) {
      this.selected = _.findIndex(this.tabDatas, (item) => item.label === label)
      this.selectedKey = this.tabDatas[this.selected].key
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: this.selectedKey
        }
      })
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-slide {
  .tab-bar-wrap {
    height: 60px;
  }
  .cube-tab-bar {
    position: fixed;
    top: 46px;
    left: 0;
    z-index: 99;
    width: 100%;
    padding-top: 12px;
    background-color: #f5f5f5;
  }
  .cube-tab {
    height: 48px;
    padding: 16px 0 8px;
    background-color: #fff;
  }
}
</style>
